<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="-5"></centerLeft>
				<div class="center-right">
					<div class="title">更换手机号码</div>
					
					<div class="forget-step flex-midden flex-center">
						<div class="forget-step-active flex-start flex-center">
							<img src="@/assets/images/dui2.png"/>
							<div>验证身份</div>
						</div>
						<div class="forget-step-dian flex-center flex-midden">
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
							<span :class="step >= 2?'active':''"></span>
						</div>
						<div class="flex-start flex-center" :class="step >= 2?'forget-step-active':'forget-step-item'">
							<img v-if="step >= 2" src="@/assets/images/dui2.png"/>
							<div v-else>2</div>
							<div>修改手机号</div>
						</div>
						<div class="forget-step-dian flex-center flex-midden">
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
							<span :class="step >= 3?'active':''"></span>
						</div>
						<div class="flex-start flex-center" :class="step >= 3?'forget-step-active':'forget-step-item'">
							<img v-if="step >= 3" src="@/assets/images/dui2.png"/>
							<div v-else>3</div>
							<div>完成更换</div>
						</div>
					</div>
									
					<div class="step-one" v-if="step == 1">
						<el-form :model="ruleForm" :rules="rules" ref="oneForm" label-width="120px">
							<div class="user-phone">已绑定的手机:{{user.phone.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2')}}</div>
							<div class="user-text">若该手机号已无法使用请联系客服</div>
						  <el-form-item label="验证码" prop="smscode">
								<el-input v-model="ruleForm.smscode" placeholder="短信验证码">
									<div slot="suffix" class="send-code" v-if="send">{{time}}S</div>
									<div slot="suffix" class="send-code" v-else @click="sendCode">获取验证码</div>
								</el-input>
						  </el-form-item>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="oneSubmit()">下一步</el-button>
					</div>
					
					
					
					<div class="step-one" v-if="step == 2">
						<el-form :model="ruleForm" :rules="rules" ref="twoForm" label-width="120px">
						  <el-form-item label="手机号码" prop="phone">
								<el-input v-model="ruleForm.phone" placeholder="手机号码">
								</el-input>
						  </el-form-item>
						  
						  <el-form-item label="验证码" prop="code">
								<el-input v-model="ruleForm.code" placeholder="短信验证码">
									<div slot="suffix" class="send-code" v-if="send">{{time}}S</div>
									<div slot="suffix" class="send-code" v-else @click="sendNewCode">获取验证码</div>
								</el-input>
						  </el-form-item>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="isSubmit" @click="twoSubmit()">下一步</el-button>
					</div>
					
					<div v-if="step == 3">
						<div class="register-three">
							<img src="@/assets/images/dui.png"/>
							<div class="register-three-title">手机号码更换成功</div>
							<div class="register-three-desc"></div>
							<div class="register-three-button" @click="toLast">返回</div>
						</div>
					</div>
					
					
					
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import {sendCurrentPhoneCode,checkPhoneCode,updatePhone} from "@/api/user"
import {smsCode} from "@/api/login"
export default {
	name: 'index',
	components:{
		centerLeft
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	data(){
		return {
			step:1,
			ruleForm:{
				smscode:"",
				phone:"",
				code:"",
			},
			rules:{
				smscode:[
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				phone:[
					{ required: true, message: '请输入手机号', trigger: 'blur' },
				],
				code:[
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
			},
			isSubmit:false,
			send:false,
			time:0,
			timeFun:null
		}
	},
	methods:{
		//验证图形验证码是否正确
		oneSubmit(){
			this.$refs['oneForm'].validate((valid) => {
				if (valid) {
					this.isSubmit = true;
					checkPhoneCode({code:this.ruleForm.smscode}).then(res=>{
						if(res.code == 1000){
							this.isSubmit = false;
							this.step = 2;
							this.send = false;
							this.time = 60;
						}else{
							this.isSubmit = false;
							return this.$message.error(res.message);
						}
					})
				}
			});
		},
		//获取短信验证码
		sendCode(){
			if(this.send){return false;}	
			sendCurrentPhoneCode({}).then(res=>{
				if(res.code == 1000){
					this.send = true;
					this.time = 60;
					this.changeTime();
				}else{
					return this.$message.error(res.message);
				}
			})
			
		},
		changeTime(){
			if(this.timeFun != null){
				clearTimeout(this.timeFun);
			}
			this.timeFun = setTimeout(()=>{
				this.time--;
				if(this.time > 0){
					this.changeTime();
				}else{
					this.send = false;
				}
			},1000);
		},
		sendNewCode(){
			if(this.send){return false;}
			if(this.ruleForm.phone == ""){
				return this.$message.error("请输入手机号");
			}
			let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
			if(!reg.test(this.ruleForm.phone)){
				return this.$message.error("请输入正确的手机号");
			}			
			smsCode({phone:this.ruleForm.phone,type:1}).then(res=>{
				if(res.code == 1000){
					this.send = true;
					this.time = 60;
					this.changeTime();
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		twoSubmit(){
			this.$refs['twoForm'].validate((valid) => {
				if (valid) {
					this.isSubmit = true;
					updatePhone({code:this.ruleForm.code,phone:this.ruleForm.phone}).then(res=>{
						if(res.code == 1000){
							this.step = 3;
							this.$store.dispatch('fetchUser');
						}else{
							this.isSubmit = false;
							return this.$message.error(res.message);
						}
					})
				}
			});
		},
		toLast(){
			window.history.go(-1);
		}
	}
}
</script>

<style lang="scss" scoped>
	
	.user-phone{
		font-size: 20px;
		font-weight: 500;
		line-height: 22px;
		text-align: center;
		color: #1D2129;
	}
	.user-text{
		opacity: 0.6;
		font-size: 16px;
		line-height: 22px;
		text-align: center;
		color: #1D2129;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	.msg-notice{
		height: 22px;
		font-weight: 400;
		font-size: 14px;
		color: #E91A12;
		line-height: 22px;
		width: 220px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: -232px;
		margin-top: -11px;
	
	}
	.send-code{
		height: 22px;
		font-weight: 400;
		font-size: 16px;
		color: rgba(233, 26, 18, 1);
		line-height: 22px;
		width: 120px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: 0px;
		margin-top: -11px;
		cursor: pointer;
	}
	.step-one{
		width: 540px;
		margin: 0 auto;
		::v-deep .el-form-item__label{
			font-size: 16px;
			color: #9E9E9E;
			&::before{
				display: none;
			}
		}
		::v-deep .el-input__inner{
			width: 420px;
			height: 48px;
			border: 1px solid rgba(7, 11, 19, 0.1);
		}
		.image-show{
			margin: 0px 0px 40px 120px;
			img{
				width: 96px;
				height: 40px;
				object-fit: contain;
			}
			div{
				font-size: 16px;
				line-height: 22px;
				color: #9E9E9E;
				cursor: pointer;
				margin-left: 16px;
				span{
					color: #E91A12;
				}
			}
		}
		.login-button{
			margin-left: 120px;
			width: 420px;
			height: 46px;
			background: #E91A12;
			font-size: 16px;
			font-weight: 500;
			color: #FFFFFF;
			border: 0px;
			margin-top: 20px;
		}
	}
	.forget-step{
		margin-bottom: 40px;
		.forget-step-dian{
			padding: 0px 15px;
			span{
				width: 4px;
				height: 4px;
				background: #E8E8E8;
				border-radius: 100%;
				display: block;
				margin: 0px 5px;
			}
			.active{
				background: rgba(233, 26, 18, 1);
			}
		}
		.forget-step-active{
			img{
				width: 28px;
				height: 28px;
				margin-right: 12px;
				flex: 0 0 28px;
			}
			div{
				font-size: 16px;
				line-height: 24px;
				color: #1D2129;
			}
		}
		.forget-step-item{
			div{
				&:first-of-type{
					width: 28px;
					height: 28px;
					border-radius: 14px;
					background: #F2F3F5;
					margin-right: 12px;
					flex: 0 0 28px;
					font-size: 16px;
					line-height: 28px;
					color: #4E5969;
					text-align: center;
				}
				&:last-of-type{
					font-size: 16px;
					line-height: 24px;
					color: rgba(78, 89, 105, 1);
				}
			}
		}
	}
	.forget-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #070B13;
		padding: 20px 40px 60px;
	}
	.register-three{
		text-align: center;
		padding-top: 30px;
		img{
			width: 64px;
			height: 64px;
		}
		.register-three-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.register-three-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 40px auto 0px;
			cursor: pointer;
		}
	}
	.title{
		font-size: 16px;
		font-weight: 500;
		line-height: 64px;
		color: #070B13;
		margin-bottom: 60px;
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
